module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_j_albino.e9d69c6a.png";